import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { replaceS3Url } from "components/Common/ReplaceS3Url"
import Spinners from "components/Common/Spinner"
import { getDivisionStart } from "store/actions"

const Home = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const sid = localStorage.getItem("sid")?.replace(/"/g, "")
  const token = localStorage.getItem("Token")?.replace(/"/g, "")
  const acad_id = localStorage.getItem("acad_id")
  const { division } = useSelector(state => state.CommonReducer)

  console.log(division)
  const [cid, setCid] = useState()
  const [dataSource, setDataSource] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setErrors] = useState(null)

  const live_Url = "https://marcopolo.prisms.in"

  const handleMediaLoad = () => {
    setLoading(false)
  }

  const getExtension = url => {
    try {
      return url?.split(".").pop().split("?")[0].toLowerCase()
    } catch {
      return ""
    }
  }
  // useEffect(() => {
  //   dispatch(
  //     getDivisionStart({
  //       acad_id,
  //     })
  //   )
  // }, [])
  const FilePreview = fileUrl => {
    const file = replaceS3Url(fileUrl)
    const ext = getExtension(file)

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return (
          <img
            src={file}
            alt="media"
            width="100%"
            onLoad={handleMediaLoad}
            className="rounded-2"
          />
        )

      case "doc":
      case "docx":
      case "xls":
      case "xlsx":
      case "ppt":
      case "pptx":
      case "pdf":
        return (
          <iframe
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(
              file
            )}&embedded=true`}
            width="100%"
            height="650px"
            title="document"
            onLoad={handleMediaLoad}
          />
        )

      case "txt":
        return (
          <iframe
            src={`data:text/plain;charset=utf-8,${encodeURIComponent(file)}`}
            width="100%"
            height="600px"
            title="text file"
            onLoad={handleMediaLoad}
          />
        )

      case "mp3":
      case "3gp":
        return (
          <audio
            controls
            onLoadedData={handleMediaLoad}
            style={{ width: "100%" }}
          >
            <source src={file} type={`audio/${ext}`} />
            Your browser does not support the audio element.
          </audio>
        )

      case "zip":
      case "rar":
        handleMediaLoad()
        return (
          <h6>
            Archive File:{" "}
            <a href={file} target="_blank" rel="noreferrer">
              Download
            </a>
          </h6>
        )

      default:
        handleMediaLoad()
        return (
          <div>
            <h6>Unsupported file type.</h6>
            <a href={file} target="_blank" rel="noreferrer">
              Download File
            </a>
          </div>
        )
    }
  }

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const [res1, res2] = await Promise.all([
          axios.post(
            "https://topschool.prisms.in/rest/index.php/staff_list.json",
            {
              fun_name: "getDocRepoByDetailsByFolderID",
              sid,
              repoId: id,
            }
          ),
          axios.post(
            "https://topschool.prisms.in/rest/index.php/staff_list.json",
            {
              fun_name: "getSubDocRepoByDetailsByFolderID",
              sid,
              repoId: id,
            }
          ),
        ])

        setDataSource([...res1.data.result, ...res2.data.result])
      } catch (err) {
        console.error("Error fetching gallery data:", err)
        setErrors(err)
      }
    }

    fetchGalleryData()
  }, [sid, id])

  useEffect(() => {
    const fetchClassDiv = async () => {
      try {
        const res = await axios.post(
          `${live_Url}/api/tscommon/division_id`,
          { acad_id },
          { headers: { Authorization: token } }
        )
        setCid(res.data[0]?.classdiv_id)
      } catch (err) {
        console.error("Error fetching class division:", err)
      }
    }

    fetchClassDiv()
  }, [acad_id, token])

  return (
    <div className="page-content">
      {loading && <Spinners />}

      {dataSource ? (
        dataSource.map(item => {
          const divisions = item.division_id?.split(",")
          if (divisions?.includes(cid?.toString())) {
            return (
              <div key={item.id} className="mb-4">
                {FilePreview(item.FILE)}
              </div>
            )
          }
          return null
        })
      ) : (
        <p className="text-danger">Not available.</p>
      )}

      {error && (
        <p className="text-danger">
          Error loading files. Please try again later.
        </p>
      )}
    </div>
  )
}

export default Home
